import { FC, DetailedHTMLProps, HTMLAttributes } from 'react'

type CodeCellProps = DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> & {
  dataTestId?: string
}

/**
 * A reusable table cell component that renders code content with ellipsis overflow handling.
 */
export const CodeCell: FC<CodeCellProps> = ({ children, dataTestId, ...props }) => (
  <code
    {...(dataTestId ? { ['data-testid']: dataTestId } : {})}
    style={{
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      width: '100%',
      ...props.style,
    }}
    {...props}
  >
    {children}
  </code>
)
